import React from 'react'
import GAEventContextManager from 'shared/components/context/ga-event-manager'
import ModalContextManager from 'shared/components/context/modal-manager'
import ReduxBridgeManager from 'shared/components/context/redux-bridge-manager'
import RefreshDataContextManager from 'shared/components/context/refresh-data-manager'
import EditAPIContextManager from './components/context/edit-api-manager'
import VideoManager from './components/context/video-manager'

const ContextManagers = ({ children }) => (
    <ReduxBridgeManager>
        <GAEventContextManager>
            <VideoManager>
                <RefreshDataContextManager>
                    <EditAPIContextManager>
                        <ModalContextManager>{children}</ModalContextManager>
                    </EditAPIContextManager>
                </RefreshDataContextManager>
            </VideoManager>
        </GAEventContextManager>
    </ReduxBridgeManager>
)

export default ContextManagers
